import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose';

import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faSignInAlt } from '@fortawesome/free-solid-svg-icons'

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

const NotAuthorizedModal = withStyles(theme => ({
    button: {
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
})) ((props) => {
    const { onClose, open, onSignIn, classes } = props;
    
    return (
        <Dialog onClose={onClose} open={open} maxWidth="lg">
            <DialogTitle>Not Authorized</DialogTitle>
            <DialogContent>
                <Button className={classes.button} variant="contained" onClick={onSignIn}>
                    <FontAwesomeIcon className={classes.leftIcon} icon={faSignInAlt}/>
                    Sign in as another user
                </Button>
                <Button className={classes.button} variant="contained" color="primary" onClick={onClose}>
                    <FontAwesomeIcon className={classes.leftIcon} icon={faAngleLeft}/>
                    Go Back
                </Button>
            </DialogContent>
        </Dialog>
    );
})

const withAuthorization = condition => Component => {
    class WithAuthorization extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                modalOpen: false,
            };
        }

        componentDidMount() {
            this.listener = this.props.firebase.onAuthUserListener(
                authUser => {
                    if (!condition(authUser)) {
                        this.setState({modalOpen: true})
                        // this.props.history.push(ROUTES.SIGN_IN);
                    }
                },
                () => this.props.history.push(ROUTES.SIGN_IN),
            );
        }
      
        componentWillUnmount() {
            this.listener();
        }

        goBack = () => {
            this.props.history.goBack();
        }

        goToSignIn = () => {
            this.props.history.push(ROUTES.SIGN_IN);
        }

        render() {
            let {modalOpen} = this.state;
            return (
                <AuthUserContext.Consumer>
                    {({authUser}) =>
                        condition(authUser) ?
                        <Component {...this.props} />
                        :
                        <NotAuthorizedModal
                            onClose={this.goBack}
                            open={modalOpen}
                            onSignIn={this.goToSignIn}
                        />
                    }
                </AuthUserContext.Consumer>
            );
        }
    }

    return compose(
        withRouter,
        withFirebase,
    )(WithAuthorization);
};

export default withAuthorization;